import React from 'react';
import {useSelector} from 'react-redux';

const BrowserCheck = () => {

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (
    <>
      <div style={{
        justifyContent: 'center',
        alignContent: 'center',
        padding: 10,
        width: width,
        height: height,}}>
        <iframe 
          src='https://www.whatismybrowser.com/feature/iframe?version_check=true&capabilities=true&cookies_third_party=true&ip_address=true&screen=true&viewmore=true'
          title='browserCheck'
          style={{
            width: width - 20,
            height: height - 20,
            padding: 10,
          }}>
        </iframe>
      </div>
    </>
  );
}

export default BrowserCheck;
